import { call, put, select, takeLatest } from 'redux-saga/effects';
import { getErrorMessageFromAPI } from '../../utilz';
import { getShipmentDraftInfoListInSuccess, getShipmentDraftInfoListListInFail } from './POShipmentDraftSearchActions';
import { getShipmentDraftInfoService } from './POShipmentDraftSearchEffects';
import POShipmentDraftSearchType from './POShipmentDraftSearchTypes';

function* getShipmentDraftInfoAction() {
  try {
    const { shipmentInfoListReq } = yield select((state) => state.poShipmentDraftSearch);

    const { data } = yield call(getShipmentDraftInfoService, shipmentInfoListReq);

    yield put(getShipmentDraftInfoListInSuccess({ data: data }));
  } catch (e) {
    yield put(getShipmentDraftInfoListListInFail({ message: getErrorMessageFromAPI(e) }));
  }
}

export default function* POShipmentDraftSearchSaga() {
  yield takeLatest(POShipmentDraftSearchType.GET_SHIPMENT_DRAFT_INFO_LIST, getShipmentDraftInfoAction);
}
